// extracted by mini-css-extract-plugin
export default {"pages":"AdminPages_pages__4WrZh","polygon_admin":"AdminPages_polygon_admin__fB+H0"};